import "@ant-design/v5-patch-for-react-19"
import React from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router-dom"
import { ConfigProvider } from "antd"
import { KindeProvider } from "@kinde-oss/kinde-auth-react"
import { QueryClientProvider } from "@tanstack/react-query"
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import * as Sentry from "@sentry/react"

import { createQueryClient } from "api/queryClient"
import { router } from "app/router"
import { DATAQ_THEME } from "theme/dataqTheme"
import { getKindeRedirectUri, getKindeLogoutUri } from "utils/server"

// Style Imports - Add stylesheet from styles folder here
import "styles/global.css"
import "styles/buttonTokens.css"
import "styles/editor.css"
import "styles/syntax-highlight.css"
import "styles/StructurePanel.css"
import "styles/AddElementModal.css"
import "styles/tour.css"

Sentry.init({
  dsn: "https://71efc190831a149b601c920b3906b82a@o4507856015458304.ingest.de.sentry.io/4507856018210896",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const queryClient = createQueryClient()

// Static antd calls (Modal.confirm, message) render outside the React tree,
// so they get the app theme here too: their buttons match the rest.
ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider theme={DATAQ_THEME}>{children}</ConfigProvider>
  ),
})

/**
 * Renders the root React element into the DOM.
 */
const rootElement = document.getElementById("root")
if (!rootElement) throw new Error("Root element not found")

const root = createRoot(rootElement)
root.render(
  <React.StrictMode>
    <KindeProvider
      audience="data-q.io/AI_Converter"
      clientId="9e1c8c527be2402e8876a194266f15ed"
      domain="https://sequence.kinde.com"
      redirectUri={getKindeRedirectUri()}
      logoutUri={getKindeLogoutUri()}
    >
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={DATAQ_THEME}>
          <RouterProvider router={router} />
        </ConfigProvider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </KindeProvider>
  </React.StrictMode>
)
